<template>
    <van-form class="edit-transport-line" ref="form" :scroll-to-error="true" @submit="handleSave" :show-error="false">

        <van-row class="title">编辑运输路线</van-row>
        <van-field label="起运地/港(Loading place/port)"
                   label-width="auto" :readonly="true" class="van-field-border van-field-required"></van-field>
        <van-row type="flex" justify="space-between">
            <van-col :span="12">
                <van-field v-model="transportLine.fromCountryLabel" :rules="rules.fromCountryRule" :readonly="true"
                           class="textarea-border"
                           @click="fromCountryVisible = true" type="textarea" autosize></van-field>
            </van-col>
            <van-col :span="12">
                <van-field v-model="transportLine.fromPortLabel" :rules="rules.fromPortRule" :readonly="true"
                           class="textarea-border"
                           @click="fromPortVisible = true" type="textarea" autosize></van-field>
            </van-col>
        </van-row>
        <van-field v-model="transportLine.fromCountryPort" class="textarea-border" type="textarea" autosize
                   placeholder="自动填入,可编辑"></van-field>

        <van-field label="指运地/港(Desigated place/port)" label-width="auto" :readonly="true"
                   class="van-field-border van-field-required"></van-field>
        <van-row type="flex" justify="space-between">
            <van-col :span="12">
                <van-field v-model="transportLine.toCountryLabel" :rules="rules.toCountryRule" :readonly="true"
                           class="textarea-border"
                           @click="toCountryVisible = true" type="textarea" autosize></van-field>
            </van-col>
            <van-col :span="12">
                <van-field v-model="transportLine.toPortLabel" :rules="rules.toPortRule" :readonly="true"
                           class="textarea-border"
                           @click="toPortVisible = true" type="textarea" autosize></van-field>
            </van-col>
        </van-row>
        <van-field v-model="transportLine.toCountryPort" class="textarea-border" type="textarea" autosize
                   placeholder="自动填入,可编辑"></van-field>

        <van-field v-model="transportLine.transportModelLabel" label="运输方式" label-width="auto" input-align="right"
                   error-message-align="right"
                   :rules="rules.transportModelRule" :readonly="true"
                   @click="transportModelVisible = true" class="van-field-border van-field-required">
            <span slot="label">运输方式<i class="extra-cont">Means of transport</i> </span>
            <i slot="extra" class="van-icon-arrow van-cell__right-icon van-icon"></i>
        </van-field>

        <van-field placeholder="请选择出运日期" v-model="transportLine.transportTime" label-width="auto" input-align="right"
                   error-message-align="right"
                   :rules="rules.transportTimeRule" :readonly="true"
                   @click="transportTimeVisible = true" class="van-field-border van-field-required">
            <span slot="label">出运日期<i class="extra-cont">Departure date</i> </span>
            <i slot="extra" class="van-icon-arrow van-cell__right-icon van-icon"></i>
        </van-field>

        <van-field v-model="transportLine.transportLine" label="运输路线" label-width="auto" type="textarea" autosize
                   placeholder="自动填入,可编辑"
                   input-align="right" error-message-align="right"
                   :rules="rules.transportLineRule" class="van-field-border van-field-required">
            <i slot="extra" class="van-icon-arrow van-cell__right-icon van-icon"></i>
        </van-field>

        <van-row class="result-footer" type="flex" justify="space-between">
            <van-button class="previous" @click.prevent="handleCancel">取消</van-button>
            <van-button class="back" native-type="submit">保存</van-button>
        </van-row>

        <!--运输日期-->
        <van-popup v-model="transportTimeVisible" position="bottom">
            <date-picker @close="transportTimeVisible = false" @confirm="transportTimeConfirm"></date-picker>
        </van-popup>

        <!--运输方式-->
        <van-popup v-model="transportModelVisible" position="bottom">
            <common-picker @close="transportModelVisible = false"
                           :columns="transportModelOptions"
                           :default-index="transportModelDefaultIndex"
                           @confirm="transportModelConfirm"></common-picker>
        </van-popup>

        <!--起运地-->
        <van-popup v-model="fromCountryVisible" position="bottom">
            <common-picker @close="fromCountryVisible = false" @confirm="fromCountryConfirm"
                           :default-index="fromCountryDefaultIndex"
                           :columns="fromCountryOptions"></common-picker>
        </van-popup>

        <!--起运港-->
        <van-popup v-model="fromPortVisible" position="bottom">
            <common-picker @close="fromPortVisible = false" @confirm="fromPortConfirm"
                           :default-index="fromPortDefaultIndex"
                           :columns="fromPortOptions"></common-picker>
        </van-popup>

        <!--目的地-->
        <van-popup v-model="toCountryVisible" position="bottom">
            <common-picker @close="toCountryVisible = false" @confirm="toCountryConfirm"
                           :default-index="toCountryDefaultIndex"
                           :columns="toCountryOptions"></common-picker>
        </van-popup>

        <!--目的港-->
        <van-popup v-model="toPortVisible" position="bottom">
            <common-picker @close="toPortVisible = false" @confirm="toPortConfirm"
                           :default-index="toPortDefaultIndex"
                           :columns="toPortOptions"></common-picker>
        </van-popup>

    </van-form>
</template>

<script>
    import {noticeManager} from "@zhoujianhui/vip-core";
    import TransportLine from '../../origin-certificate/dto/TransportLine'
    import CommonPicker from '../../component/CommonPicker'
    import DatePicker from '../../component/DatePicker'
    import DictionaryCountry from "../../origin-certificate/dto/DictionaryCountry";
    import dictionaryService from "../../component/dictionary-service";
    import certificateService from "../../origin-certificate/service/certificate-service";


    export default {
        name: "editTransportLine",
        props: {
          region: Object,
        },
        components: {
            DatePicker, CommonPicker
        },
        data() {
            return {
                transportLine: new TransportLine(),

                fromCountryOptions: [],
                fromCountryDefaultIndex: 0,
                fromPortOptions: [],
                fromPortDefaultIndex: 0,

                toCountryOptions: [],
                toCountryDefaultIndex: 0,
                toPortOptions: [],
                toPortDefaultIndex: 0,

                transportModelOptions: [],
                transportModelDefaultIndex: 2,

                fromCountryVisible: false,
                fromPortVisible: false,
                toCountryVisible: false,
                toPortVisible: false,
                transportModelVisible: false,
                transportTimeVisible: false,

                rules: TransportLine.getRule()
            }
        },
        created() {
            this.searchTransportRouteDictionary();
            this.searchTransportModelDictionary();
        },
        methods: {
          //查询国家路线字典
          async searchTransportRouteDictionary() {
            let regionCodes = ["REGION_CODE_99"];
            regionCodes.push(this.region.value);
            let result = await certificateService.getTransportRouteDictionary(regionCodes);
            if (result.isSuccess()) {
              this.fromCountryOptions = result.data.filter(country => country.countryCode === '142')
                  .map(country => new DictionaryCountry(country));
              this.toCountryOptions = result.data.filter(country => country.countryCode !== '142')
                  .map(country => new DictionaryCountry(country));

              this.initCountryAndPort(
                  this.fromCountryOptions[this.fromCountryDefaultIndex],
                  this.fromCountryOptions[this.fromCountryDefaultIndex].ports[this.fromPortDefaultIndex],
                  this.toCountryOptions[this.toCountryDefaultIndex],
                  this.toCountryOptions[this.toCountryDefaultIndex].ports[this.toPortDefaultIndex]
              );

            } else {
              noticeManager.showMessage(result.msg, result.type);
            }
          },

            async searchTransportModelDictionary() {
                let result = await dictionaryService.getDictionaryIncludeItemsById(7);
                if (result.isSuccess()) {
                    this.transportModelOptions = result.data.items.filter(item => item.enabled);
                    this.transportLine.transportModel = this.transportModelOptions[this.transportModelDefaultIndex].value;
                    this.transportLine.transportModelLabel = this.transportModelOptions[this.transportModelDefaultIndex].label;
                }
            },

            //初始化国家和港口信息
            initCountryAndPort(selectedFromCountry, selectedFromPort, selectedToCountry, selectedToPort) {
                this.fromPortOptions = selectedFromCountry.ports;
                this.transportLine.assignFromCountryAttribute(selectedFromCountry);
                this.transportLine.assignFromPortAttribute(selectedFromPort);

                this.toPortOptions = selectedToCountry.ports;
                this.transportLine.assignToCountryAttribute(selectedToCountry);
                this.transportLine.assignToPortAttribute(selectedToPort)
            },

            //起运国
            fromCountryConfirm(selectedFromCountry) {
                this.transportLine.assignFromCountryAttribute(selectedFromCountry);
                this.fromPortOptions = selectedFromCountry.ports;
                this.transportLine.assignFromPortAttribute(this.fromPortOptions[0]);

                this.fromCountryVisible = false;
            },
            fromPortConfirm(selectedFromPort) {
                this.transportLine.assignFromPortAttribute(selectedFromPort);
                this.fromPortVisible = false;
            },

            //目的国
            toCountryConfirm(selectedToCountry) {
                this.transportLine.assignToCountryAttribute(selectedToCountry);
                this.toPortOptions = selectedToCountry.ports;
                this.transportLine.assignToPortAttribute(this.toPortOptions[0]);

                this.toCountryVisible = false;
            },
            toPortConfirm(selectedToPort) {
                this.transportLine.assignToPortAttribute(selectedToPort);
                this.toPortVisible = false;
            },

            //运输方式
            transportModelConfirm(selectedTransportModel) {
                this.transportLine.transportModel = selectedTransportModel.value;
                this.transportLine.transportModelLabel = selectedTransportModel.label;
                this.transportModelVisible = false;
            },

            //运输时间
            transportTimeConfirm(data) {
                this.transportLine.transportTime = data;
                this.transportTimeVisible = false;
            },

            //取消
            handleCancel() {
                this.$emit('hideEditTransportLine');
            },

            //保存
            handleSave() {
                this.$emit('editTransportLine', Object.assign({}, this.transportLine));
            },
        }
    }
</script>

<style lang="scss" scoped>
    .edit-transport-line {
        .title {
            text-align: center;
            font-size: 0.17rem;
            font-weight: bold;
            padding: 0.2rem 0 0.15rem;
            color: #111111;
            background: #ffffff;
        }

        .result-footer {
            width: 100%;
            margin: 0 auto;
            padding: 0 4% .1rem;
            box-sizing: border-box;
            background: #ffffff;

            .van-button {
                width: 48%;
                border-radius: 4px;
                color: #ffffff;
                height: .46rem;
            }

            .previous {
                background: rgb(143, 161, 204);
            }

            .back {
                background: rgb(59, 119, 254);
                border: rgb(59, 119, 254) solid 1px;
            }

        }

        .textarea-border {
            ::v-deep {
                .van-field__body {
                    border: #bfbfc3 solid 1px;
                }
            }
        }

        ::v-deep {

            .van-field__label {
                color: #111111;
                font-weight: bold;

                .extra-cont {
                    position: absolute;
                    font-size: 12px;
                    color: #999999;
                    top: 30px;
                    left: 24px;
                    font-weight: normal;
                }

            }

            .van-field__label:before {
                content: ' ';
                background: rgb(59, 119, 254);
                position: absolute;
                width: 8px;
                height: 5px;
                display: block;
                left: 6px;
                top: 23px;
            }

            .van-field-required {
                .van-field__label:after {
                    content: "*";
                    color: #e61717;
                    font-size: .18rem;
                    position: absolute;
                    font-weight: bold;
                    top: .18rem;
                }
            }

            .van-cell.van-field {
                padding: 14px 16px 14px 24px;
            }

            .van-field-border::after {
                content: ' ';
                background: rgb(191, 191, 195);
                position: absolute;
                left: 24px;
                width: 100%;
                height: 1px;
            }

            .van-field-textarea {
                display: flex;
                flex-direction: column;

                .textarea-required:after {
                    content: "*";
                    color: #e61717;
                    font-size: .18rem;
                    position: absolute;
                    font-weight: bold;
                    top: .18rem;
                }

                .select-btn {
                    margin-left: .2rem;
                    font-size: .14rem;
                    color: #1890ff;
                }

            }

            .van-row {
                .van-col--12:first-child {
                    .van-field {
                        padding: 14px 5px 14px 24px !important;
                    }
                }

                .van-col--12:nth-child(2) {
                    .van-field {
                        padding: 14px 16px 14px 5px !important;
                    }
                }
            }
        }
    }

</style>
